import { render, staticRenderFns } from "./WarrantyDetailsGrid.vue?vue&type=template&id=8d2e77d4&"
import script from "./WarrantyDetailsGrid.vue?vue&type=script&lang=js&"
export * from "./WarrantyDetailsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports